import React, { useState, useEffect } from 'react';
import { useParams } from 'react-router-dom';

// ── Data Models (unchanged) ──────────────────────────────────────────────────
class TrackingData {
  constructor(courier, data) { this.courier = courier; this.data = data; }
}
class SteadfastConsignment {
  constructor({ createdAt, id, cusName, cusAddress, cusPhone, codAmount, trackId, invoice, status, dmId, currentHub, userId, pointDelivery, user, rider, currenthub }) {
    Object.assign(this, { createdAt, id, cusName, cusAddress, cusPhone, codAmount, trackId, invoice, status, dmId, currentHub, userId, pointDelivery, user, rider, currenthub });
  }
  static fromJson(json) {
    return new SteadfastConsignment({
      createdAt: json['created_at'], id: json['id'], cusName: json['cus_name'],
      cusAddress: json['cus_address'], cusPhone: json['cus_phone'], codAmount: json['cod_amount'],
      trackId: json['track_id'], invoice: json['invoice'], status: json['status'],
      dmId: json['dm_id'], currentHub: json['current_hub'], userId: json['user_id'],
      pointDelivery: json['point_delivery'],
      user: json['user'] ? { id: json['user']['id'], bName: json['user']['b_name'] } : null,
      rider: json['rider'] ? { id: json['rider']['id'], name: json['rider']['name'], phone: json['rider']['phone'] } : null,
      currenthub: json['currenthub'] ? { id: json['currenthub']['id'], name: json['currenthub']['name'], phone: json['currenthub']['phone'] } : null,
    });
  }
}
class SteadfastTrackingHistory {
  constructor(data) { Object.assign(this, data); }
  static fromJson(json) {
    return new SteadfastTrackingHistory({
      id: json['id'], consignmentId: json['consignment_id'], senderId: json['sender_id'],
      trackingType: json['tracking_type'], icon: json['icon'], text: json['text'],
      userType: json['user_type'], userId: json['user_id'], deliverymanId: json['deliveryman_id'],
      adminId: json['admin_id'], updatedBy: json['updated_by'], confirmStatus: json['confirm_status'],
      status: json['status'], hideSender: json['hide_sender'], createdAt: json['created_at'],
      updatedAt: json['updated_at'],
      deliveryman: json['deliveryman'] ? {
        id: json['deliveryman']['id'], name: json['deliveryman']['name'], phone: json['deliveryman']['phone'],
      } : null,
    });
  }
}
class PathaoConsignment {
  static fromJson(json) {
    return { cusName: json['cus_name'], cusAddress: json['cus_address'], cusPhone: json['cus_phone'], invoice: json['invoice'], codAmount: json['cod_amount'] };
  }
}
class PathaoTrackingHistory {
  static fromJson(json) {
    return { datetime: json['datetime'], type: json['type'], title: json['title'], status: json['status'], remarks: json['remarks'], current_location_text: json['current_location_text'] };
  }
}

// ── Main Component ───────────────────────────────────────────────────────────
export default function ParcelTrackingPage() {
  const { id } = useParams();
  const [trackId, setTrackId] = useState(id || '');
  const [trackingResponse, setTrackingResponse] = useState(null);
  const [isLoading, setIsLoading] = useState(false);
  const [errorMessage, setErrorMessage] = useState(null);

  useEffect(() => { if (id) { setTrackId(id); fetchTrackingData(id); } }, [id]);

  const fetchTrackingData = async (tid) => {
    if (!tid) { setErrorMessage('Please enter a tracking ID.'); return; }
    setIsLoading(true); setErrorMessage(null); setTrackingResponse(null);
    try {
      const res = await fetch(`https://aman-life-style-bd-main-server-974485829900.asia-south1.run.app/api/track/${tid}`);
      if (!res.ok) throw new Error(`Status: ${res.status}`);
      const json = await res.json();
      let parsed;
      if (json.courier === 'steadfast') {
        parsed = new TrackingData('steadfast', {
          consignment: SteadfastConsignment.fromJson(json.data[0]),
          trackingHistory: json.data[1].map(x => SteadfastTrackingHistory.fromJson(x)),
        });
      } else if (json.courier === 'pathao') {
        parsed = new TrackingData('pathao', {
          consignment: PathaoConsignment.fromJson(json.data.consignment),
          trackingHistory: json.data.tracking_history.map(x => PathaoTrackingHistory.fromJson(x)),
        });
      } else { throw new Error(`Unknown courier: ${json.courier}`); }
      setTrackingResponse(parsed);
    } catch (e) { setErrorMessage(`Error: ${e.message}`); }
    finally { setIsLoading(false); }
  };

  const getSteadfastStatus = (status) => {
    const map = {
      1: { text: 'Pending', color: '#f59e0b', bg: '#fef3c7' },
      2: { text: 'Delivered Approval Pending', color: '#d97706', bg: '#fef3c7' },
      3: { text: 'Partial Delivered', color: '#10b981', bg: '#d1fae5' },
      4: { text: 'Cancelled Approval Pending', color: '#ef4444', bg: '#fee2e2' },
      5: { text: 'Unknown Pending', color: '#6b7280', bg: '#f3f4f6' },
      6: { text: 'Delivered', color: '#059669', bg: '#d1fae5' },
      7: { text: 'Partial Delivered', color: '#10b981', bg: '#d1fae5' },
      8: { text: 'Cancelled', color: '#ef4444', bg: '#fee2e2' },
      9: { text: 'Hold', color: '#b91c1c', bg: '#fee2e2' },
      10: { text: 'In Review', color: '#7c3aed', bg: '#ede9fe' },
      18: { text: 'Delivered by Rider', color: '#059669', bg: '#d1fae5' },
    };
    return map[status] || { text: 'Unknown', color: '#6b7280', bg: '#f3f4f6' };
  };

  const getPathaoStatusStyle = (status) => {
    const s = (status || '').toLowerCase();
    if (s.includes('delivered')) return { color: '#059669', bg: '#d1fae5' };
    if (s.includes('cancel')) return { color: '#ef4444', bg: '#fee2e2' };
    if (s.includes('hold')) return { color: '#b91c1c', bg: '#fee2e2' };
    if (s.includes('pending')) return { color: '#f59e0b', bg: '#fef3c7' };
    if (s.includes('transit') || s.includes('review')) return { color: '#7c3aed', bg: '#ede9fe' };
    return { color: '#6b7280', bg: '#f3f4f6' };
  };

  const formatDate = (d) => {
    if (!d) return 'N/A';
    try { return new Date(d).toLocaleString('en-GB', { day: '2-digit', month: 'short', year: 'numeric', hour: '2-digit', minute: '2-digit', hour12: true }); }
    catch { return 'N/A'; }
  };

  const sortedHistory = (history, dateKey) =>
    [...history].sort((a, b) => {
      const da = a[dateKey] ? new Date(a[dateKey]) : null;
      const db = b[dateKey] ? new Date(b[dateKey]) : null;
      if (!da && !db) return 0; if (!da) return 1; if (!db) return -1;
      return db - da;
    });

  // ── render ──
  return (
    <>
      <style>{`
        @import url('https://fonts.googleapis.com/css2?family=Hind+Siliguri:wght@300;400;500;600;700&display=swap');
        * { box-sizing: border-box; margin: 0; padding: 0; }
        body { font-family: 'Hind Siliguri', sans-serif; }
        .track-page { background: #f5f5f5; min-height: 100vh; padding: 80px 0 40px; font-family: 'Hind Siliguri', sans-serif; }
        .track-container { max-width: 860px; margin: 0 auto; padding: 0 16px; }

        /* Hero search bar */
        .search-hero { background: #fff; border: 1px solid #e8e8e8; border-radius: 4px; padding: 28px 28px 24px; margin-bottom: 20px; }
        .search-hero h1 { font-size: 20px; font-weight: 700; color: #282c3f; margin-bottom: 4px; letter-spacing: -0.01em; }
        .search-hero p { font-size: 13px; color: #94a3b8; margin-bottom: 18px; }
        .search-row { display: flex; gap: 10px; }
        .search-input { flex: 1; padding: 11px 16px; border: 1.5px solid #e2e8f0; border-radius: 4px; font-size: 14px; font-family: inherit; color: #282c3f; outline: none; transition: border-color 0.2s; }
        .search-input:focus { border-color: #ff3f6c; }
        .search-input::placeholder { color: #aaa; }
        .search-btn { padding: 11px 28px; background: #ff3f6c; color: #fff; border: none; border-radius: 4px; font-size: 14px; font-weight: 600; cursor: pointer; font-family: inherit; letter-spacing: 0.01em; transition: background 0.2s; white-space: nowrap; }
        .search-btn:hover { background: #e0355e; }

        /* Card */
        .card { background: #fff; border: 1px solid #e8e8e8; border-radius: 4px; margin-bottom: 16px; overflow: hidden; }
        .card-header { padding: 14px 20px; border-bottom: 1px solid #f0f0f0; display: flex; align-items: center; gap: 10px; }
        .card-header-icon { width: 32px; height: 32px; border-radius: 50%; background: #fff0f3; display: flex; align-items: center; justify-content: center; flex-shrink: 0; }
        .card-title { font-size: 14px; font-weight: 700; color: #282c3f; letter-spacing: 0.02em; text-transform: uppercase; }
        .card-body { padding: 16px 20px; }

        /* Info grid */
        .info-grid { display: grid; grid-template-columns: 1fr 1fr; gap: 0; }
        .info-row { display: flex; flex-direction: column; padding: 10px 14px; border-bottom: 1px solid #f5f5f5; border-right: 1px solid #f5f5f5; }
        .info-row:nth-child(even) { border-right: none; }
        .info-row:last-child, .info-row:nth-last-child(2):nth-child(odd) { border-bottom: none; }
        .info-label { font-size: 11px; color: #94a3b8; font-weight: 500; text-transform: uppercase; letter-spacing: 0.06em; margin-bottom: 3px; }
        .info-value { font-size: 14px; color: #282c3f; font-weight: 500; line-height: 1.4; }

        /* Status badge */
        .badge { display: inline-flex; align-items: center; padding: 3px 10px; border-radius: 20px; font-size: 12px; font-weight: 600; }

        /* Courier chip */
        .courier-chip { display: inline-flex; align-items: center; gap: 6px; padding: 4px 12px; background: #282c3f; color: #fff; border-radius: 20px; font-size: 12px; font-weight: 600; letter-spacing: 0.04em; }

        /* Timeline */
        .timeline { padding: 4px 0; }
        .timeline-item { display: flex; gap: 14px; position: relative; }
        .timeline-left { display: flex; flex-direction: column; align-items: center; width: 28px; flex-shrink: 0; }
        .timeline-dot { width: 28px; height: 28px; border-radius: 50%; display: flex; align-items: center; justify-content: center; flex-shrink: 0; z-index: 1; }
        .timeline-line { width: 2px; flex: 1; background: #f0f0f0; min-height: 16px; }
        .timeline-content { flex: 1; padding-bottom: 20px; }
        .timeline-title { font-size: 14px; font-weight: 600; color: #282c3f; margin-bottom: 3px; line-height: 1.4; }
        .timeline-date { font-size: 12px; color: #94a3b8; margin-bottom: 6px; }
        .timeline-meta { font-size: 12px; color: #64748b; margin-top: 4px; }
        .timeline-item:last-child .timeline-line { display: none; }
        .timeline-item:last-child .timeline-content { padding-bottom: 0; }

        /* States */
        .state-box { padding: 48px 24px; text-align: center; }
        .state-icon { margin: 0 auto 14px; }
        .state-title { font-size: 15px; font-weight: 600; color: #282c3f; margin-bottom: 6px; }
        .state-sub { font-size: 13px; color: #94a3b8; }
        .spinner { width: 36px; height: 36px; border: 3px solid #f0f0f0; border-top: 3px solid #ff3f6c; border-radius: 50%; animation: spin 0.8s linear infinite; margin: 0 auto 14px; }
        @keyframes spin { to { transform: rotate(360deg); } }
        .retry-btn { margin-top: 14px; padding: 9px 22px; background: #282c3f; color: #fff; border: none; border-radius: 4px; font-size: 13px; font-weight: 600; cursor: pointer; font-family: inherit; }
        .retry-btn:hover { background: #1a1d2b; }

        @media (max-width: 600px) {
          .search-row { flex-direction: column; }
          .info-grid { grid-template-columns: 1fr; }
          .info-row { border-right: none; }
          .info-row:nth-last-child(2):nth-child(odd) { border-bottom: 1px solid #f5f5f5; }
        }
      `}</style>

      <div className="track-page">
        <div className="track-container">

          {/* Search Hero */}
          <div className="search-hero">
            <div style={{ display: 'flex', alignItems: 'flex-start', justifyContent: 'space-between', flexWrap: 'wrap', gap: 8, marginBottom: 16 }}>
              <div>
                <h1>Track Your Parcel</h1>
                <p>Enter your tracking ID to get real-time updates</p>
              </div>
              {trackingResponse && (
                <span className="courier-chip">
                  <svg width="12" height="12" viewBox="0 0 24 24" fill="currentColor">
                    <path d="M20 8h-3V4H3c-1.1 0-2 .9-2 2v11h2c0 1.66 1.34 3 3 3s3-1.34 3-3h6c0 1.66 1.34 3 3 3s3-1.34 3-3h2v-5l-3-4zM6 18.5c-.83 0-1.5-.67-1.5-1.5s.67-1.5 1.5-1.5 1.5.67 1.5 1.5-.67 1.5-1.5 1.5zm13.5-9l1.96 2.5H17V9.5h2.5zm-1.5 9c-.83 0-1.5-.67-1.5-1.5s.67-1.5 1.5-1.5 1.5.67 1.5 1.5-.67 1.5-1.5 1.5z"/>
                  </svg>
                  {trackingResponse.courier.charAt(0).toUpperCase() + trackingResponse.courier.slice(1)}
                </span>
              )}
            </div>
            <div className="search-row">
              <input
                className="search-input"
                type="text"
                placeholder="e.g. SF123456789"
                value={trackId}
                onChange={e => setTrackId(e.target.value)}
                onKeyDown={e => e.key === 'Enter' && fetchTrackingData(trackId)}
              />
              <button className="search-btn" onClick={() => fetchTrackingData(trackId)}>
                Track Now
              </button>
            </div>
          </div>

          {/* Loading */}
          {isLoading && (
            <div className="card">
              <div className="state-box">
                <div className="spinner" />
                <div className="state-title">Loading tracking data…</div>
                <div className="state-sub">Please wait a moment</div>
              </div>
            </div>
          )}

          {/* Error */}
          {errorMessage && !isLoading && (
            <div className="card">
              <div className="state-box">
                <div className="state-icon">
                  <svg width="44" height="44" viewBox="0 0 24 24" fill="none">
                    <circle cx="12" cy="12" r="10" fill="#fee2e2" />
                    <path d="M12 7v5M12 16v.5" stroke="#ef4444" strokeWidth="2" strokeLinecap="round" />
                  </svg>
                </div>
                <div className="state-title">Could not load data</div>
                <div className="state-sub">{errorMessage}</div>
                <button className="retry-btn" onClick={() => fetchTrackingData(trackId)}>Try Again</button>
              </div>
            </div>
          )}

          {/* Results */}
          {trackingResponse && !isLoading && !errorMessage && (() => {
            const c = trackingResponse.data.consignment;
            const isSF = trackingResponse.courier === 'steadfast';
            const sfStatus = isSF ? getSteadfastStatus(c.status) : null;

            return (
              <>
                {/* Consignment Card */}
                <div className="card">
                  <div className="card-header">
                    <div className="card-header-icon">
                      <svg width="16" height="16" viewBox="0 0 24 24" fill="#ff3f6c">
                        <path d="M20 7H4a2 2 0 00-2 2v10a2 2 0 002 2h16a2 2 0 002-2V9a2 2 0 00-2-2zM4 5h16v2H4V5z"/>
                      </svg>
                    </div>
                    <span className="card-title">Shipment Details</span>
                    {isSF && (
                      <span className="badge" style={{ background: sfStatus.bg, color: sfStatus.color, marginLeft: 'auto', fontSize: 12 }}>
                        {sfStatus.text}
                      </span>
                    )}
                  </div>
                  <div className="info-grid">
                    {[
                      ['Recipient', c.cusName],
                      ['Invoice', c.invoice],
                      ['Phone', c.cusPhone],
                      ['COD Amount', c.codAmount !== undefined ? `৳ ${Number(c.codAmount).toFixed(2)}` : 'N/A'],
                      ['Address', c.cusAddress, true],
                      isSF && c.user?.bName ? ['Merchant', c.user.bName] : null,
                      isSF && c.rider?.name ? ['Rider', c.rider.name] : null,
                      isSF && c.rider?.phone ? ['Rider Phone', c.rider.phone] : null,
                      isSF && c.currenthub?.name ? ['Current Hub', c.currenthub.name] : null,
                      isSF && c.currenthub?.phone ? ['Hub Phone', c.currenthub.phone] : null,
                    ].filter(Boolean).map(([label, value, full], i) => (
                      <div key={i} className="info-row" style={full ? { gridColumn: '1 / -1' } : {}}>
                        <span className="info-label">{label}</span>
                        <span className="info-value">{value || 'N/A'}</span>
                      </div>
                    ))}
                  </div>
                </div>

                {/* Timeline Card */}
                <div className="card">
                  <div className="card-header">
                    <div className="card-header-icon">
                      <svg width="16" height="16" viewBox="0 0 24 24" fill="#ff3f6c">
                        <path d="M12 2C6.48 2 2 6.48 2 12s4.48 10 10 10 10-4.48 10-10S17.52 2 12 2zm.5 5v5.25l4.5 2.67-.75 1.23L11 13V7h1.5z"/>
                      </svg>
                    </div>
                    <span className="card-title">Tracking History</span>
                    <span style={{ marginLeft: 'auto', fontSize: 12, color: '#94a3b8' }}>
                      {trackingResponse.data.trackingHistory.length} events
                    </span>
                  </div>
                  <div className="card-body">
                    {trackingResponse.data.trackingHistory.length === 0 ? (
                      <div style={{ textAlign: 'center', padding: '32px 0', color: '#94a3b8', fontSize: 14 }}>No history available yet.</div>
                    ) : (
                      <div className="timeline">
                        {isSF
                          ? sortedHistory(trackingResponse.data.trackingHistory, 'createdAt').map((item, i, arr) => {
                              const st = getSteadfastStatus(item.status);
                              return (
                                <div key={item.id || i} className="timeline-item">
                                  <div className="timeline-left">
                                    <div className="timeline-dot" style={{ background: st.bg }}>
                                      <svg width="12" height="12" viewBox="0 0 24 24" fill={st.color}>
                                        <path d="M9 16.17L4.83 12l-1.42 1.41L9 19 21 7l-1.41-1.41z"/>
                                      </svg>
                                    </div>
                                    {i < arr.length - 1 && <div className="timeline-line" />}
                                  </div>
                                  <div className="timeline-content">
                                    <div className="timeline-title">{item.text || 'No description'}</div>
                                    <div className="timeline-date">{formatDate(item.createdAt)}</div>
                                    <span className="badge" style={{ background: st.bg, color: st.color }}>{st.text}</span>
                                    {item.deliveryman?.name && <div className="timeline-meta">🏍 Rider: {item.deliveryman.name} {item.deliveryman.phone && `· ${item.deliveryman.phone}`}</div>}
                                  </div>
                                </div>
                              );
                            })
                          : sortedHistory(trackingResponse.data.trackingHistory, 'datetime').map((item, i, arr) => {
                              const st = getPathaoStatusStyle(item.status);
                              return (
                                <div key={i} className="timeline-item">
                                  <div className="timeline-left">
                                    <div className="timeline-dot" style={{ background: st.bg }}>
                                      <svg width="12" height="12" viewBox="0 0 24 24" fill={st.color}>
                                        <path d="M20 8h-3V4H3c-1.1 0-2 .9-2 2v11h2c0 1.66 1.34 3 3 3s3-1.34 3-3h6c0 1.66 1.34 3 3 3s3-1.34 3-3h2v-5l-3-4z"/>
                                      </svg>
                                    </div>
                                    {i < arr.length - 1 && <div className="timeline-line" />}
                                  </div>
                                  <div className="timeline-content">
                                    <div className="timeline-title">{item.title || 'No title'}</div>
                                    <div className="timeline-date">{formatDate(item.datetime)}</div>
                                    <span className="badge" style={{ background: st.bg, color: st.color }}>{item.status || 'Unknown'}</span>
                                    {item.current_location_text && <div className="timeline-meta">📍 {item.current_location_text}</div>}
                                    {item.remarks && <div className="timeline-meta">💬 {item.remarks}</div>}
                                  </div>
                                </div>
                              );
                            })
                        }
                      </div>
                    )}
                  </div>
                </div>
              </>
            );
          })()}

          {/* Empty state */}
          {!trackingResponse && !isLoading && !errorMessage && trackId && (
            <div className="card">
              <div className="state-box">
                <div className="state-icon">
                  <svg width="44" height="44" viewBox="0 0 24 24" fill="none">
                    <circle cx="12" cy="12" r="10" fill="#f3f4f6" />
                    <path d="M8 12h8M12 8v8" stroke="#d1d5db" strokeWidth="2" strokeLinecap="round" />
                  </svg>
                </div>
                <div className="state-title">No data found</div>
                <div className="state-sub">No parcel found for ID: <strong>{trackId}</strong></div>
              </div>
            </div>
          )}

        </div>
      </div>
    </>
  );
}